export default __webpack_public_path__ + "static/media/radicle-logo.86c6bb2c.svg";